import { cleanQueryParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class FAVRCreatorAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'favr-creator' });
  }
  /**
   * Allow company/system admin to apply adjusted rate values
   * @param {object} params
   * @param {string} params.email
   * @param {string} params.companyId
   */
  async fetchFavrRates(params) {
    const queryParams = cleanQueryParams({
      companyId: params?.companyId,
      email: params?.searchTerm,
    });
    const result = await handleApiCalls('get', `${this.baseUrl}/rates?${queryParams}`);

    return result.data;
  }

  /**
   * Fetch comparison rates for suggestions
   * @param {object} params
   * @param {string} params.zmyr - Format: make-model#year#retentionYears#retentionMileage
   * @param {string} params.state - User's state
   * @param {string} [params.companyId] - Optional company ID
   */
  async fetchComparisonRates(params) {
    const queryParams = cleanQueryParams({
      generateCosts: true,
      zmyr: params?.zmyr,
      state: params?.state,
      companyId: params?.companyId,
    });
    const result = await handleApiCalls('get', `${this.baseUrl}/rates?${queryParams}`);

    return result.data;
  }

  /**
   * Save generated FAVR rate
   * @param {object} rateData - Complete rate data including form values, rates, and address
   */
  async saveRate(rateData) {
    const result = await handleApiCalls('post', `${this.baseUrl}/save-rate`, rateData);

    return result.data;
  }
}

export default FAVRCreatorAPI;
